// extracted by mini-css-extract-plugin
export var list = "project-footer-module--list--WnsgO";
export var item = "project-footer-module--item--WTZAH";
export var star = "project-footer-module--star--EneGC";
export var circle = "project-footer-module--circle--EIHwG";